import {chain, find} from "lodash";
import {createSelector} from "reselect";
import {IStore} from "modules/types";
import {buildHelpPathName} from "modules/utils";

export const getHelpContent = ({help}: IStore) => help.help_content;

export const getTabs = createSelector(getHelpContent, (help) => {
	if (!help) {
		return [];
	}

	return chain(help.sections.sections).sortBy("position").value();
});

export const getSectionIdByName = createSelector(
	getHelpContent,
	(help) =>
		(section_name: string = "") => {
			const section = find(help?.sections.sections, (section) =>
				buildHelpPathName(section.name).includes(section_name)
			);

			return section?.id || 0;
		}
);

export const getHelpPageContentById = createSelector(
	getHelpContent,
	(help) => (section_id: number) => {
		if (!help) {
			return [];
		}

		return chain(help.articles.articles)
			.filter((article) => article?.section_id === section_id)
			.orderBy(["position"], ["asc"])
			.value();
	}
);
